module.exports = __webpack_public_path__ + "media/images/ai-bg-fd67e325.jpg";